/* eslint-disable */
import React, { useEffect, useState, useContext } from "react";
import { Link, useParams } from "react-router-dom";

import clipboardCopy from "clipboard-copy";

import { assetImages } from "constants";

const ShareModal = ({ copyMessage }) => {
  return (
    <div className="registration_modal share_modal">
      <div className="modal fade" id="share_mdl">
        <div className="modal-dialog ">
          <div className="modal-content">
            <div className="modal-header  justify-content-between position-relative">
              <div className="signin_hdng ">
                <h3>Share this item</h3>
              </div>
              <button
                type="button"
                className="close d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="material-icons-outlined">close</i>
              </button>
            </div>
            <div className="modal-body">
              {/* <div className="share_social_row pb-4 mb-4 pt-3">
                <ul className="list_style_none d-flex gap-2 justify-content-between">
                  <li>
                    <Link to="#" className="d-block">
                      <span className="d-block text-center mb-2">
                        <img src={assetImages.embedIcon} alt="" />
                      </span>
                      <span className="d-block text-center share_text text-primary fw-medium">
                        Embade
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="d-block">
                      <span className="d-block text-center mb-2">
                        <img src={assetImages.whatsAppIcon} alt="" />
                      </span>
                      <span className="d-block text-center share_text text-primary fw-medium">
                        WhatsApp
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="d-block">
                      <span className="d-block text-center mb-2">
                        <img src={assetImages.skypIcon} alt="" />
                      </span>
                      <span className="d-block text-center share_text text-primary fw-medium">
                        Skype
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="d-block">
                      <span className="d-block text-center mb-2">
                        <img src={assetImages.facebookIcon} alt="" />
                      </span>
                      <span className="d-block text-center share_text text-primary fw-medium">
                        Facebook
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="d-block">
                      <span className="d-block text-center mb-2">
                        <img src={assetImages.twitterIcon} alt="" />
                      </span>
                      <span className="d-block text-center share_text text-primary fw-medium">
                        Twitter
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="d-block">
                      <span className="d-block text-center mb-2">
                        <img src={assetImages.instagramIcon} alt="" />
                      </span>
                      <span className="d-block text-center share_text text-primary fw-medium">
                        Instagram
                      </span>
                    </Link>
                  </li>
                </ul>
              </div> */}
              <div className="share_copy_link">
                <div className="form-group input_fill">
                  <label className="text-primary fw-bold mb-2">Copy Link</label>
                  <div className="copy_fill position-relative">
                    <input
                      type="text"
                      value={copyMessage}
                      className="form-control"
                      placeholder=""
                      readOnly
                    />
                    <Link
                      to="#"
                      className="link_copy position-absolute"
                      onClick={() => {
                        clipboardCopy(copyMessage);
                      }}
                    >
                      <span className="material-icons-outlined text-primary-gray fs-lg">
                        content_copy
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
